import { InspirationsActionType } from './enums';
import { InspirationsAction, InspirationsState } from './interfaces';

export const initialState: InspirationsState = {
	inspirationsList: [],
	inspirationsError: null,
	inspirationsLoading: false,
	inspirationDetails: {},
	inspirationDetailsError: null,
	inspirationDetailsLoading: false,

	inspirationProductMapping: {},
	inspirationProductMappingError: null,
	inspirationProductMappingLoading: false,
	totalRecords: 0,
	shortlistedInspirationsList: [],
	shortlistedInspirationsError: null,
	shortlistedInspirationsLoading: false
};

export default (state = initialState, { type, payload }: InspirationsAction): InspirationsState => {
	switch (type) {
		case InspirationsActionType.STORE_ALL_INSPIRATIONS:
			return {
				...state,
				inspirationsList: payload.isAppend
					? [...state.inspirationsList, ...payload.inspiration]
					: payload.inspiration,
				totalRecords: payload.totalRecords
			};

		case InspirationsActionType.ERROR_ALL_INSPIRATIONS: {
			return {
				...state,
				inspirationsLoading: false,
				inspirationsError: payload.error
			};
		}

		case InspirationsActionType.RESET_INSPIRATION_DATA: {
			return {
				...state,
				inspirationsList: []
			};
		}

		case InspirationsActionType.STORE_INSPIRATION_DETAILS: {
			return {
				...state,
				inspirationDetails: payload,
				inspirationDetailsError: payload.error,
				inspirationDetailsLoading: false
			};
		}
		case InspirationsActionType.ERROR_INSPIRATION_DETAILS: {
			return {
				...state,
				inspirationDetailsLoading: false,
				inspirationDetailsError: payload.error
			};
		}

		case InspirationsActionType.STORE_INSPIRATION_PRODUCT_MAPPINGS: {
			return {
				...state,
				inspirationProductMapping: payload,
				inspirationProductMappingError: payload.error,
				inspirationProductMappingLoading: false
			};
		}
		case InspirationsActionType.ERROR_INSPIRATION_PRODUCT_MAPPINGS: {
			return {
				...state,
				inspirationProductMappingLoading: false,
				inspirationProductMappingError: payload.error
			};
		}

		case InspirationsActionType.STORE_SHORTLISTED_INSPIRATIONS:
			return {
				...state,
				shortlistedInspirationsList: payload.shortlistedInspiration,
				totalRecords: payload.totalRecords
			};
		case InspirationsActionType.ERROR_SHORTLISTED_INSPIRATIONS: {
			return {
				...state,
				shortlistedInspirationsLoading: false,
				shortlistedInspirationsError: payload.error
			};
		}
		default:
			return state;
	}
};
